import axios from 'axios';
import { Feed } from 'views/self-service/features/feed-catalog/types/feed.type';
import { CreateFeedInput } from '../types/create-feed-input.type';

// POST FEED
// /ewosapi/v1/shrimps/Feed/{globalCompanyId}
export const postFeed = async (globalCompanyId: string, request: CreateFeedInput) => {
  const res = await axios.post<Feed>(`/ewosapi/v1/shrimps/Feed/${globalCompanyId}`, request);
  return res.data;
};
